import window from 'common/window'

interface IGAUserProperties {
  user_app: string
  scoir_session_id?: string
  user_id?: string
}

const initialize = (userProperties: IGAUserProperties) => {
  window.gtag('config', window.GA4_TAG, { user_id: userProperties.user_id })
  window.gtag('set', 'user_properties', userProperties)
}

export default initialize
